<template>
  <!-- <page-layout :avatar="avatar"> -->
    <!-- <div slot="headerContent" style="height:60px;position:relative;">
      <div class="title" style="font-size:14px;">
        <span class="welcome-text" :style="welcomeStyle">{{ welcome }}</span>
      </div>
      <div :style="postStyle">
        『 {{ userInfo.realname }} | {{ postName }} |
        {{ departName || '上级单位' }} 』
      </div>
    </div> -->

    <div>
      <a-row :gutter="24">
        <a-col :xl="18" :lg="24" :md="24" :sm="24" :xs="24">
          <a-card
            :loading="loading"
            :bordered="false"
            style="margin-bottom: 24px;"
            :body-style="{padding: '12px'}"
          >
            <!-- <a-card-grid style="width:25%;textAlign:'center'">
              <a-card-meta>
                <div
                  slot="title"
                  class="card-title"
                  style="width:90%;height:90%;"
                  @click="handleWait()"
                >
                  <div style="float:left;width:30%">
                    <a-avatar size="large" src="/images/time_00.png" />
                  </div>
                  <div style="float:left;width:65%;">
                    <a style="margin-left:10px;margin-top:-10px;color:black;font-size:14px;">我的待办</a>
                    <div style="margin-left:10px;font-size:12px;font-weight:300;">处理待办消息记录</div>
                  </div>
                </div>
              </a-card-meta>
            </a-card-grid>
            <a-card-grid style="width:25%;textAlign:'center'">
              <a-card-meta>
                <div
                  slot="title"
                  class="card-title"
                  style="width:90%;height:90%;"
                  @click="handleDone()"
                >
                  <div style="float:left;width:30%">
                    <a-avatar size="large" src="/images/home_00.png" />
                  </div>
                  <div style="float:left;width:65%;">
                    <a style="margin-left:10px;margin-top:-10px;color:black;font-size:14px;">我的已办</a>
                    <div style="margin-left:10px;font-size:12px;font-weight:300;">查看已办消息记录</div>
                  </div>
                </div>
              </a-card-meta>
            </a-card-grid>
            <a-card-grid style="width:25%;textAlign:'center'">
              <a-card-meta>
                <div
                  slot="title"
                  class="card-title"
                  style="width:90%;height:90%;"
                  @click="handleAnnounce()"
                >
                  <div style="float:left;width:30%">
                    <a-avatar size="large" src="/images/tongzhi_00.png" />
                  </div>
                  
                  <div style="float:left;width:65%;">
                    <a style="margin-left:10px;margin-top:-10px;color:black;font-size:14px;">我的消息</a>
                    <div style="margin-left:10px;font-size:12px;font-weight:300;">重要信息全员播报</div>
                  </div>
                </div>
              </a-card-meta>
            </a-card-grid>
            <a-card-grid style="width:25%;textAlign:'center'">
              <a-card-meta>
                <div slot="title" class="card-title" style="width:90%;height:90%;" @click="handleCc()">
                  <div style="float:left;width:30%">
                    <a-avatar size="large" src="/images/list_00.png" />
                  </div>
                  <div style="float:left;width:65%;">
                    <a style="margin-left:10px;margin-top:-10px;color:black;font-size:14px;">抄送我的</a>
                    <div style="margin-left:10px;font-size:12px;font-weight:300;">抄送我的消息记录</div>
                  </div>
                </div>
              </a-card-meta>
            </a-card-grid> -->
            <a-tabs>
              <a-tab-pane key="1" :tab="$t('待办任务')">
                <div style="display: flex;justify-content: space-between;padding-bottom: 10px;">
                  <div>{{ $t('我的待办') }}【{{count1}}】</div>
                  <div><a @click="handleWait()">{{ $t('更多') }} >></a></div>
                </div>
                  <a-table
                    ref="table"
                    size="middle"
                    :scroll="{x:true}"
                    bordered
                    rowKey="procInsId"
                    :pagination="false"
                    :columns="columns1"
                    :dataSource="dataSource1"
                    :loading="loading"
                    @change="handleTableChange">
                    
                    <template slot="procDefVersion" slot-scope="text, record, index">
                        <el-tag size="medium" >V{{ record.procDefVersion }}</el-tag>
                    </template>
                    <template slot="startUserName" slot-scope="text, record, index">
                       <label>{{record.startUserName}} <el-tag type="info" size="mini">{{record.startDeptName}}</el-tag></label>
                    </template>
                  </a-table>
              </a-tab-pane>
              <a-tab-pane key="2" :tab="$t('已办任务')">
                <div style="display: flex;justify-content: space-between;padding-bottom: 10px;">
                  <div>{{ $t('我的已办') }}【{{count2}}】</div>
                  <div><a @click="handleDone()">{{ $t('更多') }} >></a></div>
                </div>
                  <a-table
                    ref="table"
                    size="middle"
                    :scroll="{x:true}"
                    bordered
                    rowKey="procInsId"
                    :pagination="false"
                    :columns="columns2"
                    :dataSource="dataSource2"
                    :loading="loading"
                    @change="handleTableChange">
                    
                    <template slot="procDefVersion" slot-scope="text, record, index">
                        <el-tag size="medium" >V{{ record.procDefVersion }}</el-tag>
                    </template>
                    <template slot="startUserName" slot-scope="text, record, index">
                       <label>{{record.startUserName}} <el-tag type="info" size="mini">{{record.startDeptName}}</el-tag></label>
                    </template>
                  </a-table>
              </a-tab-pane>
            </a-tabs>
            <!-- <a-card-grid style="width:50%;">
            </a-card-grid>
            <a-card-grid style="width:50%;">
            </a-card-grid> -->
          </a-card>

          

          <a-card :loading="loading" :title="$t('公告面板')" :bordered="false" class="notice">
            <a slot="extra" @click="handleGg()">{{ $t('更多') }} >></a>
            <a-list item-layout="horizontal" :data-source="dataSource">
              <a-list-item slot="renderItem" slot-scope="item, index" @click="goNotice(item)">
                <a-list-item-meta :description="item.announceTitle">
                  <a slot="title">{{ $t(['行政公告','红头文件','新闻资讯','赏罚通报','市场观察'][item.announceFirstType]) }}</a>
                </a-list-item-meta>
                <div>{{item.sendTime}}</div>
              </a-list-item>
            </a-list>
          </a-card>
        </a-col>
        <a-col style="padding: 0 12px" :xl="6" :lg="24" :md="24" :sm="24" :xs="24">
          <a-card
            :title="$t('便捷导航')"
            style="margin-bottom: 24px"
            :bordered="false"
            :body-style="{padding: 0}"
          >
            <div class="item-group">
              <div style="margin:5px 0px;">
                <!-- <a-badge :count="count1">
                  <a-tag color="purple" @click="handleWait()" style="margin-bottom:10px;">我的待办</a-tag>
                </a-badge>
                <a-tag color="cyan" @click="handleDone()" style="margin-bottom:10px;">我的已办</a-tag>
                <a-tag color="pink" @click="handleAnnounce()" style="margin-bottom:10px;">我的消息</a-tag> -->
                <div>
                  <a-tag v-for="item in quickList" :key="item.id" color="purple" closable @click="handleGo(item)" @close.stop="handleClose(item)" style="margin-bottom:10px;">{{item.name}}</a-tag>
                  <a-tag color="blue" icon="plus" @click="handleAddQuick">
                    <a-icon type="plus" />
                    {{ $t('添加') }}</a-tag>
                </div>
                
              </div>
            </div>
          </a-card>
          <a-card :title="$t('工程报装')" style="margin-bottom: 24px" :bordered="false" :body-style="{padding: 0}">
            <div class="item-group">
              <div style="margin:5px 0px;">
                <a-badge :count="count4">
                  <a-tag color="purple" @click="handleWaitGc()" style="margin-bottom:10px;">{{ $t('我的待办') }}</a-tag>
                </a-badge>
              </div>
            </div>
          </a-card>
          <a-card
            :loading="loading"
            :title="$t('申请面板')"
            :bordered="false"
            style="margin-bottom: 24px;"
            :body-style="{padding: 0}"
          >
            <a-card-grid style="width:33.33%;height: 82px;textAlign:'center'" v-for="item in list">
              <a-card-meta>
                <div
                  slot="title"
                  class="card-title"
                  style="width:90%;height:90%;"
                  @click="handleFlow(item)"
                >
                  <div style="float:left;width:20%">
                    <a-avatar :size="20" :src="imgList[Math.floor(Math.random() * 6)]" />
                  </div>
                  <div style="float:left;width:75%;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">
                    <a style="margin-left:10px;margin-top:-10px;color:black;font-size:14px;">{{item.workName}}</a>
                    <div style="margin-left:10px;font-size:12px;font-weight:300;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">{{item.workRemark}}</div>
                  </div>
                </div>
              </a-card-meta>
            </a-card-grid>
          </a-card>
        
          <template>
            <div>
              <!-- 向上箭头 -->
              <a-back-top style="right:10px;" />
            </div>
          </template>
        </a-col>
      </a-row>
      <show-announcement ref="ShowAnnouncement" @ok="modalFormOk"></show-announcement>
      <selectQuickMenu ref="selectQuickMenu" @myQuickMenu="myQuickMenu"></selectQuickMenu>
    </div>
    
  <!-- </page-layout> -->
</template>

<script>
import { timeFix, welcome } from "@/utils/util";
import { getAction,deleteAction } from '@/api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { mixinDevice } from '@/utils/mixin'
import ShowAnnouncement from '@/components/tools/ShowAnnouncement'
import selectQuickMenu from './selectQuickMenu'

import PageLayout from "@/components/page/PageLayout";
import HeadInfo from "@/components/tools/HeadInfo";
import Radar from "@/components/chart/Radar";
import * as manageAPI from "@/api/manage";
import * as tools from "@/utils/util";
import Vue from 'vue'
import { SYS_TYPE } from "@/store/mutation-types"
import store from '@/store/'

const DataSet = require("@antv/data-set");

export default {
  name: "Workplace",
  components: {
    PageLayout,
    HeadInfo,
    Radar,
    ShowAnnouncement,
    selectQuickMenu
  },
  mixins:[JeecgListMixin, mixinDevice],
  data() {
    return {
      timeFix: timeFix(),
      welcome: welcome(),
      postName: "",
      departName: "",
      avatar: "",
      user: {},
      welcomeStyle: {},
      postStyle: {
        "margin-top": "-5px",
        "margin-left": "-113px",
        flex: "auto",
        position: "absolute",
        left: "92px",
        transform: "scale(0.8)"
      },
      projects: [],
      loading: true,
      radarLoading: true,
      activities: [],
      nodelist: [],
      teams: [],
      radarData: [],
      list: [],
      listUrl: "/jeecg-oa/workBench/oaWorkbench/list",
      imgList: ['/images/list_00.png','/images/email_00.png','/images/game_00.png','/images/jiushui_00.png','/images/caidan.png','/images/sweet_00.png'],
      url:{
        list: "/jeecg-oa/notice/bsAnnounce/list",
        oaqueryById: "/jeecg-oa/notice/bsAnnounce/queryById",
        gcList:"/jeecg-engineering/engineering/installationDetail/list",
        todoListNew: "/jeecg-oa/flowable/task/todoListNew",
        finishedListNew: "/jeecg-oa/flowable/task/finishedListNew",
        userMenu: "/jeecg-system/user/userMenuDetail/list",
        userMenuDel: "/jeecg-system/user/userMenuDetail/delete",
      },
      dataSource: [],
      queryParam:{
        bpmStatus:1
      },
      count1:0,
      count2:0,
      count3:0,
      count4:0,
      dataSource1:[],
      dataSource2:[],
      quickList: [],
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    columns1() {
      return [
        {
          title: '#',
          dataIndex: '',
          key:'rowIndex',
          width:60,
          align:"center",
          customRender: (t, r, index) => {
            return parseInt(index)+1;
          }
        },
        {
          title: this.$t('任务编号'),
          align:"center",
          dataIndex: 'procInsId',
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('流程名称'),
          align:"center",
          dataIndex: 'procDefName',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('流程发起人'),
          align:"center",
          dataIndex: 'startUserName',
          scopedSlots: { customRender: 'startUserName' },
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('接收时间'),
          align:"center",
          dataIndex: 'createTime',
          width: 150,
          ellipsis: true,
        },
      ]
    },
    columns2() {
      return [
        {
          title: '#',
          dataIndex: '',
          key:'rowIndex',
          width:60,
          align:"center",
          customRender: (t, r, index) => {
            return parseInt(index)+1;
          }
        },
        {
          title: this.$t('任务编号'),
          align:"center",
          dataIndex: 'procInsId',
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('流程名称'),
          align:"center",
          dataIndex: 'procDefName',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('流程发起人'),
          align:"center",
          dataIndex: 'startUserName',
          scopedSlots: { customRender: 'startUserName' },
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('接收时间'),
          align:"center",
          dataIndex: 'createTime',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('审批时间'),
          align:"center",
          dataIndex: 'finishTime',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('耗时'),
          align:"center",
          dataIndex: 'duration',
          width: 150,
          ellipsis: true,
        },
      ]
    },
  },
  async created() {
    this.user = this.userInfo;

    console.log("this.avatar :" + this.avatar);

    //设置员工岗位信息/部门信息
    try {
      let params = {username: this.user.username};
      this.v_user = await manageAPI.queryByUsername(params);
      console.log("this.v_user",this.v_user);
      this.postName = this.v_user.result.post;

      //设置头像信息
      this.avatar =
        window._CONFIG["imgDomainURL"] + "/" + this.v_user[0]["avatar"];
    } catch (error) {
      console.log("工作台设置员工岗位信息/部门信息异常：" + error);
    }
    getAction(this.listUrl,{pageSize: 999}).then(res=>{
      if(res.success){
        this.list = res.result.records;
      }
    });
    getAction(this.url.list,{pageSize: 999,bpmStatus:1}).then(res=>{
      if(res.success){
        this.dataSource = res.result.records.splice(0,5);
      }
    });
    // 工程报装-我的待办数量
    getAction(this.url.gcList,{workState: 0}).then(res=>{
      if(res.success){
        this.count4 = res.result.total;
      }
    })
    // OA办公-我的待办数量
    getAction(this.url.todoListNew,{pageNo:1,pageSize:5}).then(res=>{
      if(res.success){
        this.dataSource1 = res.result.records;
        this.count1 = res.result.total;
      }
    })
    // OA办公-我的已办数量
    getAction(this.url.finishedListNew,{pageNo:1,pageSize:5}).then(res=>{
      if(res.success){
        this.dataSource2 = res.result.records;
        this.count2 = res.result.total;
      }
    })
    this.myQuickMenu();
  },
  mounted() {
    try {
      //this.getActivity();
      this.loading = false;
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    // 获取我的快捷导航
    myQuickMenu(){
      getAction(this.url.userMenu,{userId:this.$store.getters.userInfo.id,sysType:10,pageSize:999}).then((res) => {
        if (res.success) {
          this.quickList = res.result.records;
        } else {
          this.$message.warning(res.message);
        }
      })
    },
    // 跳转
    handleGo(item){
      Vue.ls.set(SYS_TYPE,10);
      store.commit('SET_SYSTYPE', 10);
      this.$router.replace({ path: item.url });
    },
    // 关闭
    handleClose(item){
      deleteAction(this.url.userMenuDel,{id:item.id}).then((res) => {
        if (res.success) {
          this.myQuickMenu();
        } else {
          this.$message.warning(res.message);
        }
      })
    },
    // 添加
    handleAddQuick(){
      this.$refs.selectQuickMenu.show();
    },
    handleGg(){
      this.$router.push(`/OAoffice/noticeManagement/ViewAnnouncement`);
    },
    getActivity() {
      this.$http.get("/api/workplace/activity").then(res => {
        this.activities = res.result;
      });
    },

    /**
     * @function 跳转到个人中心
     */
    handleMyCenter() {
      //跳转到相应页面
      this.$router.push(`/account/center`);
    },
    /**
     * @function 跳转到我的待办
     */
    handleWait() {
      //跳转到我的待办
      this.$router.push(`/OAoffice/flowable/task/todo/index`);
    },
    // 工程报装-我的待办
    handleWaitGc() {
        Vue.ls.set(SYS_TYPE,7);
        store.commit('SET_SYSTYPE', 7);
        this.$router.replace({ path: "/engineeringInstallation/constructionManagement/toDoList" });
    },
    /**
     * @function 跳转到我的已办
     */
    handleDone() {
      //跳转到我的已办
      this.$router.push(`/OAoffice/flowable/task/finished/index`);
    },
    /**
     * @function 跳转到我的公告
     */
    handleAnnounce() {
      //跳转到我的消息
      this.$router.push(`/OAoffice/noticeManagement/MyMessage`);
    },
    handleCc(){
      // 跳转抄送我的
      this.$router.push(`/OAoffice/flowable/task/cc/index`);
    },
    goNotice(row){
      this.$refs.ShowAnnouncement.detail(row);
    },
    handleFlow(row){
      // 跳转流程中
      this.$router.push({ path: '/OAoffice/flowable/task/record/index',
        query: {
          deployId: row.deploymentId,
          procDefId:row.procDefId,
          procKey:row.procKey,
          taskId: row.taskId,
          category: row.category,
          finished: true,
          metaTitle: row.workName,
          isOaRoute: '/account/settings/Workplace',
      }})
    },
    /**
     * @function 跳转到我的收藏
     */
    handleCollect() {
      //跳转到我的收藏
      this.$router.push(`/workflow/collection`);
    },
    /**
     * @function 跳转到消息通知页面
     */
    handleMessage() {
      //跳转到相应页面
      this.$router.push(`/account/settings/notification`);
    },
  
    /**
     * @function 跳转到部门管理界面
     */
    handleDepartManage() {
      let path = `/isystem/depart`;
      //跳转到相应页面
      this.$router.push({
        path: path,
        fullPath: path,
        meta: { title: this.$t("部门管理") }
      });
    },
    /**
     * @function 跳转到角色维护界面中
     */
    handleRoleSetupManage() {
      let path = `/isystem/roleUserList`;
      //跳转到相应页面
      this.$router.push({
        path: path,
        fullPath: path,
        meta: { title: this.$t("角色维护") }
      });
    },
    
    /**
     * @function 跳转到用户管理页面
     */
    handleUserManage() {
      var path = "/isystem/user";
      //跳转到相应页面
      this.$router.push({
        path: path,
        fullPath: path,
        meta: { title: this.$t("用户管理") }
      });
    },
    /**
     * @function 跳转到角色管理页面
     */
    handleRoleManage() {
      var path = "/isystem/role";
      //跳转到相应页面
      this.$router.push({
        path: path,
        fullPath: path,
        meta: { title: this.$t("角色管理") }
      });
    },
   
    /**
     * @function 跳转到菜单管理界面中
     */
    handleMenuManage() {
      var path = "/isystem/permission";
      //跳转到相应页面
      this.$router.push({
        path: path,
        fullPath: path,
        meta: { title: this.$t("菜单管理") }
      });
    },
    /**
     * @function 跳转到表单管理界面中
     */
    handleTableManage() {
      var path = "/online/cgform";
      //跳转到相应页面
      this.$router.push({
        path: path,
        fullPath: path,
        meta: { title: this.$t("表单管理") }
      });
    },
    /**
     * @function 跳转到数据字典界面中
     */
    handleDictManage() {
      var path = "/isystem/dict";
      //跳转到相应页面
      this.$router.push({
        path: path,
        fullPath: path,
        meta: { title: this.$t("数据字典") }
      });
    },
   
  }
};
</script>

<style lang="less" scoped>
.project-list {
  .card-title {
    font-size: 0;

    a {
      color: rgba(0, 0, 0, 0.85);
      margin-left: 12px;
      line-height: 24px;
      height: 24px;
      display: inline-block;
      vertical-align: top;
      font-size: 14px;

      &:hover {
        color: #1890ff;
      }
    }
  }
  .card-description {
    color: rgba(0, 0, 0, 0.45);
    height: 44px;
    line-height: 22px;
    overflow: hidden;
  }
  .project-item {
    display: flex;
    margin-top: 8px;
    overflow: hidden;
    font-size: 12px;
    height: 20px;
    line-height: 20px;
    a {
      color: rgba(0, 0, 0, 0.45);
      display: inline-block;
      flex: 1 1 0;

      &:hover {
        color: #1890ff;
      }
    }
    .datetime {
      color: rgba(0, 0, 0, 0.25);
      flex: 0 0 auto;
      float: right;
    }
  }
  .ant-card-meta-description {
    color: rgba(0, 0, 0, 0.45);
    height: 44px;
    line-height: 22px;
    overflow: hidden;
  }
}

.item-group {
  padding: 20px 0 20px 24px;
  font-size: 0;
  a {
    color: rgba(0, 0, 0, 0.65);
    display: inline-block;
    font-size: 14px;
    margin-bottom: 13px;
    width: 25%;
  }
}

.members {
  a {
    display: block;
    margin: 12px 0;
    line-height: 24px;
    height: 24px;
    .member {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      line-height: 24px;
      max-width: 100px;
      vertical-align: top;
      margin-left: 12px;
      transition: all 0.3s;
      display: inline-block;
    }
    &:hover {
      span {
        color: #1890ff;
      }
    }
  }
}

.ant-back-top {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  -webkit-font-feature-settings: "tnum";
  font-feature-settings: "tnum";
  position: fixed;
  right: 10px;
  bottom: 50px;
  z-index: 10;
  width: 40px;
  height: 40px;
  cursor: pointer;
}

.mobile {
  .project-list {
    .project-card-grid {
      width: 100%;
    }
  }

  .more-info {
    border: 0;
    padding-top: 16px;
    margin: 16px 0 16px;
  }

  .headerContent .title .welcome-text {
    display: none;
  }
}
.notice{
  /deep/.ant-card-body{
    padding: 12px;
  }
}
/deep/.ant-table-thead > tr > th{
  background-color: #fafafa;
}
/deep/.ant-table-thead > tr > th:not(:first-child):before,
/deep/.ant-table-thead > tr > th:not(:last-child):after{
  background-color: #e8e8e8;
}
/deep/.ant-badge-count, /deep/.ant-badge-dot, /deep/.ant-badge .ant-scroll-number-custom-component{
  right: 5px;
}
// .ant-tag{
//   margin-left: 15px;
// }
</style>